import React, { useEffect } from "react";
import { Box, Link } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { colors, fonts, gradients } from "../theme/tokens";

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about-us" },
  { label: "Services", href: "/services" },
  { label: "News & Insights", href: "/news" },
  { label: "Contact", href: "/contact-us" },
];

const Error = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <Box
        sx={{
          mt: "72px",
          minHeight: { xs: "calc(100vh - 72px)", md: "80vh" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          px: { xs: "20px", md: "28px" },
          py: { xs: "60px", md: "80px" },
        }}
      >
        {/* Watermark */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: { xs: "200px", sm: "280px", md: "400px" },
            color: "rgba(20,38,59,.04)",
            lineHeight: 1,
            userSelect: "none",
            pointerEvents: "none",
            whiteSpace: "nowrap",
          }}
        >
          404
        </Box>

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            maxWidth: "560px",
          }}
        >
          <Box
            sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}
          >
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              PAGE NOT FOUND
            </Box>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
          </Box>
          <Box
            component="h1"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: { xs: "28px", sm: "34px", md: "42px" },
              color: colors.navyInk,
              lineHeight: 1.15,
              letterSpacing: "-.02em",
              mt: "16px",
              mb: "16px",
            }}
          >
            Oops! This page doesn't exist.
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: { xs: "15px", md: "16px" },
              color: colors.mutedText,
              lineHeight: 1.7,
              mb: "36px",
            }}
          >
            The page you are looking for may have been moved, removed, or simply
            never existed. Let us help you find your way back.
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "center",
              gap: "14px",
              mb: "48px",
              maxWidth: { xs: "320px", sm: "none" },
              mx: "auto",
            }}
          >
            <Link
              href="/"
              underline="none"
              sx={{
                width: { xs: "100%", sm: "auto" },
                textAlign: "center",
                background: gradients.amber,
                color: "#fff",
                fontFamily: fonts.body,
                fontSize: "15px",
                fontWeight: 700,
                px: "30px",
                py: "15px",
                borderRadius: "44px",
                boxShadow: "0 14px 32px -14px rgba(242,121,28,.7)",
              }}
            >
              Go to Homepage
            </Link>
            <Link
              href="/contact-us"
              underline="none"
              sx={{
                width: { xs: "100%", sm: "auto" },
                textAlign: "center",
                background: "#fff",
                color: colors.brandNavy,
                fontFamily: fonts.body,
                fontSize: "15px",
                fontWeight: 700,
                px: "30px",
                py: "15px",
                borderRadius: "44px",
                border: `1px solid ${colors.line}`,
              }}
            >
              Contact Us
            </Link>
          </Box>

          <Box>
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12px",
                fontWeight: 600,
                color: colors.subtleText,
                letterSpacing: ".16em",
                mb: "16px",
              }}
            >
              QUICK LINKS
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              {quickLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  underline="none"
                  sx={{
                    fontFamily: fonts.body,
                    fontSize: "13px",
                    fontWeight: 600,
                    color: colors.mutedText,
                    background: "#fff",
                    border: `1px solid ${colors.lineSoft}`,
                    px: "16px",
                    py: "8px",
                    borderRadius: "40px",
                    transition: "all .2s ease",
                    "&:hover": {
                      borderColor: colors.steelBlue,
                      color: colors.steelBlue,
                    },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default Error;
